
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.5 19c.7 0 1.292-.242 1.775-.725.483-.483.725-1.075.725-1.775s-.242-1.292-.725-1.775C17.792 14.242 17.2 14 16.5 14s-1.292.242-1.775.725C14.242 15.208 14 15.8 14 16.5s.242 1.292.725 1.775c.483.483 1.075.725 1.775.725zm5.1 4l-2.7-2.675a4.572 4.572 0 01-2.4.675c-1.25 0-2.313-.438-3.188-1.313C12.438 18.813 12 17.75 12 16.5c0-1.25.438-2.313 1.313-3.188C14.187 12.438 15.25 12 16.5 12c1.25 0 2.313.438 3.188 1.313C20.563 14.187 21 15.25 21 16.5c0 .45-.063.88-.188 1.288a4.844 4.844 0 01-.512 1.137L23 21.6 21.6 23zM5 22c-.55 0-1.02-.196-1.413-.587A1.926 1.926 0 013 20V4c0-.55.196-1.02.587-1.413A1.926 1.926 0 015 2h8l6 6v2.5a6.48 6.48 0 00-2.5-.5 6.51 6.51 0 00-2.613.525A6.097 6.097 0 0011.8 12H7v2h3.5a5.779 5.779 0 00-.313.975A8.326 8.326 0 0010.025 16H7v2h3.175a6.327 6.327 0 001 2.288A5.975 5.975 0 0013.025 22H5zm7-13h5l-5-5v5z"}})])
          )
        }
      }
    